<template>
  <div :class="`content-box content-box--pale-mint-grey`">
    <slot />
  </div>
</template>

<script>
export default {
  name: "ContentBox"
}
</script>

<style lang="scss" scoped>
.content-box {
  padding: $spacing-24 $spacing-16;

  border-radius: $spacing-4;

  &--pale-mint-grey {
    background-color: $pale-mint-grey;
  }
}
</style>
